import React, { useEffect, useState } from 'react';

import Select from 'react-select'

import apiClient from 'api/apiClient';

import Error from 'Components/Form/Error';

const GYM_TEAMS = "Gym Teams";
const CENTRAL_FUNCTIONS = "Central Functions";

const TabButton = ( { label, isSelected, setSelectedTeamTab } ) =>
{
    if ( isSelected === true )
    {
        return <button className="rounded-b-none bg-pgdarkteal text-pgsurface mt-2" type="reset" onClick={() => setSelectedTeamTab ( label )}>{label}</button>
    }
    else
    {
        return <button className="rounded-b-none bg-pgtealtrans text-pgsurface mt-2" type="reset" onClick={() => setSelectedTeamTab ( label )}>{label}</button>
    }
}

function RegisterSelectTeams ( { selectedTeams, setSelectedTeams } ) 
{
    const [ isLoading, setIsLoading ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );
    const [ allTeams, setAllTeams ] = useState ( null );

    const [ gymSearchText, setGymSearchText ] = useState ( "" );
    const [ selectedGym, setSelectedGym ] = useState ( null );

    const [ allGymTeams, setAllGymTeams ] = useState ( [] );
    const [ allCentralFunctionLocations, setAllCentralFunctionLocations ] = useState ( [] );
    const [ allCentralFunctionTeams, setAllCentralFunctionTeams ] = useState ( [] );
    const [ selectedCentralFunctionLocation, setSelectedCentralFunctionLocation ] = useState ( null );
    const [ selectedCentralFunctionTeam, setSelectedCentralFunctionTeam ] = useState ( null );

    const [ selectedTeamTab, setSelectedTeamTab ] = useState ( GYM_TEAMS );

    useEffect ( () => {

        if ( isLoading === false && allTeams === null )
        {
            setIsLoading ( true );

            apiClient.get ( "/teams", 
                { 
                    headers: { 
                        "Content-Type": "application/json" } 
                } )
                .then ( response => {
                    setAllTeams ( response.data );
                    setAllGymTeams ( response.data.filter ( value => value.location !== "Central Functions" ).map ( value => { return { label: value.team, value: value.team } } ).sort ( ( a, b ) => a.label.toLowerCase ().localeCompare ( b.label.toLowerCase () ) ) );
                    setAllCentralFunctionLocations ( response.data.filter ( value => value.location === "Central Functions" && value.region !== null ).map ( value => { return { label: value.region, value: value.region } } ).sort ( ( a, b ) => a.label.toLowerCase ().localeCompare ( b.label.toLowerCase () ) ) );
                    setAllCentralFunctionTeams ( response.data.filter ( value => value.location === "Central Functions" && value.team !== null ).map ( value => { return { label: value.team, value: value.team } } ).sort ( ( a, b ) => a.label.toLowerCase ().localeCompare ( b.label.toLowerCase () ) ) );
                    setIsLoading ( false );
                    setError ( { isError: false, message: null } );
                } )
                .catch ( error => {
                    setAllTeams ( [] );
                    setIsLoading ( false );
                    setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                } );
        }

    }, [ allTeams ] );

    const handleSelectGym = ( gym ) =>
    {
        setSelectedGym ( gym );
        const teams = allTeams.find ( team => team.team === gym.label );
        setSelectedTeams ( teams );
    }

    const handleSelectCentralFunctionLocation = ( l ) =>
    {
        setSelectedCentralFunctionLocation ( l );
        const teams = allTeams.find ( team => team.region === l.label );

        setSelectedTeams ( teams );
        setSelectedTeams ( { location: teams.location, region: teams.region, team: selectedTeams?.team } );
    }

    const handleSelectCentralFunctionTeam = ( t ) =>
    {
        setSelectedCentralFunctionTeam ( t );
        const teams = allTeams.find ( team => team.team === t.label );
        setSelectedTeams ( { location: teams.location, region: selectedTeams?.region, team: teams.team } );
    }

    const gymTeams = <div className="flex flex-col gap-2 pt-4">
                        <Select styles={{
                                    control: ( baseStyles, state ) => ( {
                                            ...baseStyles,
                                            borderRadius: '0.5rem',
                                        } )                               
                            }} options={allGymTeams} value={selectedGym} name="select gym" placeholder="Select your gym" onChange={(e) => handleSelectGym ( e )} />
                        { selectedGym && <p>Your teams: { selectedTeams.location } &rarr;  { selectedTeams.region } &rarr;  { selectedTeams.team }</p> }
                    </div>;

    const centralFunctionTeams = <div className="flex flex-col gap-2 pt-4">
                        <Select styles={{
                                    control: ( baseStyles, state ) => ( {
                                            ...baseStyles,
                                            borderRadius: '0.5rem',
                                        } )                               
                            }} options={allCentralFunctionLocations} value={selectedCentralFunctionLocation} name="select location" placeholder="Select your work location" onChange={(e) => handleSelectCentralFunctionLocation ( e )} />
                        <Select styles={{
                                    control: ( baseStyles, state ) => ( {
                                            ...baseStyles,
                                            borderRadius: '0.5rem',
                                        } )                               
                            }} options={allCentralFunctionTeams} value={selectedCentralFunctionTeam} name="select team" placeholder="Select your function" onChange={(e) => handleSelectCentralFunctionTeam ( e )} />                            
                        { selectedCentralFunctionLocation && selectedCentralFunctionTeam && <p>Your teams: { selectedTeams.location } &rarr;  { selectedTeams.region } &rarr;  { selectedTeams.team }</p> }
                    </div>;

    return  <div className="py-2">
                <label>Select Teams</label>
                <div className="flex gap-2">
                    <TabButton isSelected={selectedTeamTab === GYM_TEAMS} label="Gym Teams" setSelectedTeamTab={ ( tab ) => setSelectedTeamTab ( tab ) } />
                    <TabButton isSelected={selectedTeamTab === CENTRAL_FUNCTIONS} label="Central Functions" setSelectedTeamTab={ ( tab ) => setSelectedTeamTab ( tab ) } />
                </div>
                <hr className="border-pgdarkteal" />
                { selectedTeamTab === GYM_TEAMS ? gymTeams : centralFunctionTeams }
                { error.isError && <Error message={error.message} /> }
            </div>
}

export default RegisterSelectTeams;
